import axios from 'axios';
import {
  setContent,
  setCorporateContent,
  setLanguage,
} from '../slices/contentSlice';

export const changeLanguage = (language) => {
  return async (dispatch) => {
    dispatch(setLanguage({ language }));
  };
};

export const getStrapiContent = () => {
  return async (dispatch) => {
    try {
      const response = await axios.get(process.env.REACT_APP_CONTENT_URL);
      const data = response?.data?.data?.[0]?.attributes;
      
      const contentData = {
        authContent: data?.web_auth?.data?.attributes,
        individualContent: data?.account_opening_and_kyc?.data?.attributes,
        dashboardContent: data?.web_dashboard?.data?.attributes,
        settingContent: data?.web_setting?.data?.attributes,
        investmentContent: data?.web_investment?.data?.attributes,
        fundsContent: data?.web_fund?.data?.attributes,
        reportsContent: data?.web_report?.data?.attributes,
        transferContent: data?.web_transfer?.data?.attributes,
        tradingContent: data?.web_trading?.data?.attributes,
        helpContent: data?.web_help?.data?.attributes,
        notificationsContent: data?.web_notification?.data?.attributes,
      };

      dispatch(setContent(contentData));
      dispatch(setCorporateContent(data?.corporate_form?.data?.attributes));
    } catch (error) {}
  };
};
